(function() {
  if (window.NHGalleryMobileExperiment) {
    return;
  }
  window.NHGalleryMobileExperiment = true;

  var switchClass = 'nht-gallery-mobile-b';
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var bound = [];

  function isVariantActive() {
    return document.documentElement.classList.contains(switchClass) && mobileQuery.matches;
  }

  function getFlickity(slideshow) {
    return window.Flickity && typeof Flickity.data === 'function' ? Flickity.data(slideshow) : null;
  }

  function update(entry) {
    var flkty = entry.flkty;

    if (!flkty || !flkty.slides || !flkty.slides.length) {
      return;
    }

    var total = flkty.slides.length;
    var index = flkty.selectedIndex + 1;

    entry.count.textContent = index + '/' + total;
    entry.bar.style.width = (index / total * 100) + '%';
  }

  function applyAlign(entry) {
    var flkty = entry.flkty;
    var align = isVariantActive() ? 'left' : 'center';

    if (!flkty || entry.align === align) {
      return;
    }

    if (flkty.isAnimating || flkty.isDragging) {
      flkty.once('settle', function() {
        applyAlign(entry);
      });
      return;
    }

    flkty.options.cellAlign = align;
    flkty.resize();
    entry.align = align;
  }

  function attach(entry) {
    var flkty = getFlickity(entry.slideshow);

    if (!flkty || flkty === entry.flkty) {
      return;
    }

    entry.flkty = flkty;
    entry.align = flkty.options.cellAlign || 'center';
    flkty.on('select', function() {
      update(entry);
    });
    applyAlign(entry);
    update(entry);
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-ab-nh-gallery-mobile]').forEach(function(ui) {
      if (ui.hasAttribute('data-ab-nh-gallery-mobile-bound')) {
        return;
      }

      var gallery = ui.closest('.product__photos--nh-gallery-ab-test');
      var slideshow = gallery && gallery.querySelector('[data-product-photos]');

      if (!slideshow) {
        return;
      }

      ui.setAttribute('data-ab-nh-gallery-mobile-bound', '');

      var entry = {
        ui: ui,
        slideshow: slideshow,
        flkty: null,
        count: ui.querySelector('[data-ab-nh-gallery-mobile-count]'),
        bar: ui.querySelector('[data-ab-nh-gallery-mobile-bar]')
      };

      ui.querySelector('[data-ab-nh-gallery-mobile-next]').addEventListener('click', function() {
        attach(entry);
        if (entry.flkty) {
          entry.flkty.next(true);
        }
      });

      entry.observer = new MutationObserver(function() {
        if (slideshow.classList.contains('flickity-enabled')) {
          attach(entry);
        }
      });
      entry.observer.observe(slideshow, {attributes: true, attributeFilter: ['class']});

      bound.push(entry);
      attach(entry);
    });
  }

  function refreshAll() {
    bound.forEach(function(entry) {
      attach(entry);
      applyAlign(entry);
    });
  }

  function unbind(root) {
    bound = bound.filter(function(entry) {
      if (root.contains(entry.ui)) {
        entry.observer.disconnect();
        return false;
      }
      return true;
    });
  }

  new MutationObserver(refreshAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', refreshAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
    });
  } else {
    init();
  }
  window.addEventListener('load', refreshAll);

  document.addEventListener('shopify:section:load', function(evt) {
    init(evt.target);
  });
  document.addEventListener('shopify:section:unload', function(evt) {
    unbind(evt.target);
  });
})();
